/* @flow */

import React from 'react';
import FsLightbox from 'fslightbox-react';

import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { setPopupOpen } from '../../actions/popup';
import { lockScroll, unlockScroll } from '../../DOMUtils';
import type { TDispatch } from '../../types/core';

const Root = styled.div`
	.fslightbox {
		&-container {
			width: 100%;
			background: rgba(245, 245, 245, 0.9);
		}

		&-slide-btn,
		&-toolbar {
			background: transparent;
		}

		&-svg-path {
			fill: #000;
		}

		&-slide-btn-container:hover .fslightbox-svg-path,
		&-toolbar-button:hover .fslightbox-svg-path {
			fill: ${(props) => props.theme.primaryColor};
		}

		&-slide-number-container {
			color: #000;
		}
		&-source {
			&:not(.fslightbox-youtube-iframe) {
				max-width: 100% !important;
				height: auto !important;
			}
		}

		&-slash {
			background-color: #000;
		}
	}
`;

type Props = {
	toggler: boolean,
	source?: string,
	sources?: Array<string>,
	types?: Array<string>,
	type?: string,
	sourceIndex?: number,
};

const Lightbox = ({ toggler, source, sources, types, type, sourceIndex }: Props) => {
	const dispatch: TDispatch = useDispatch();

	const openLightbox = () => {
		lockScroll();
		dispatch(setPopupOpen(true));
	};

	const closeLightbox = () => {
		unlockScroll();
		dispatch(setPopupOpen(false));
	};

	return (
		<Root>
			<FsLightbox
				toggler={toggler}
				source={source}
				sources={sources}
				type={type}
				types={types}
				sourceIndex={sourceIndex}
				onOpen={openLightbox}
				key={source ?? sources.length}
				onClose={closeLightbox}
				disableLocalStorage
				exitFullscreenOnClose
			/>
		</Root>
	);
};

Lightbox.defaultProps = {
	source: undefined,
	sources: [],
	types: [],
	sourceIndex: 0,
	type: 'image',
};

export default Lightbox;
